import React from "react";
import '../CSS/Projects.css'

const Projects = () => {

    return (
    <div>
        <h1>Projects and presentations</h1>
        
        <p className="projects-intro"> Here is a short list of some projects and presentations I have been involved in recently.
            I have only included some project from last couple of years,to keep this section short and concise. 
            I keep this list up-to-date so that this remains a good representation of what I am currently doing. This list is
            comprised of different projects I contribute to in three different capacities, namely:
        </p>
        <ul>
            <li>As part of my role as Chief Data Scientist/ML-Data Engineer at <a>Atea As</a></li>
            <li>As a result of my role as a mentor at <a>Springboard</a> where I get to supervise and contribute to multiple student projects</li>
            <li>Personal/private projects I undertake</li>
        </ul>
        <p className="projects-intro">Please don't hesitate to reach out if you are wondering about any of these and please take a look at my LinkedIn for a more 
            "CV-like" description of the various roles I have had.
        </p>
        <div className="algo-hedging-box">
        <h3>Algo hedging strategy</h3>
            <p className="algo-hedging-text">
             This project is a private project whereby I have created a functional algoritmic strategy where operations are design to
             cover one another in order to minimize risk (at the expense of giving up potentially larger profits). I have built the strategy using
             a combination of C++ and Python by making use of various techniques with a particular focus on Reinforcement learning.
            </p>
        </div>
        <img className='algo-hedging-img' alt='' src={require('../Static/Trading.jpg')}></img>


        <div className="IoT-infra-box">
            <h3>IoT ML architecture</h3>
            <p className="IoT-infra-text">
            I have recently developed a prototype for private customer that was interested in having IoT edge processing capabilities for
            thousands of IoT devices that were installed in remote locations. I presented an anonimized version of the prototype during 
            a sharing session at the NCC (Norwegian Cognitive Center) in Bergen, Norway.
            </p>

        </div>
        <img className='IoT-infra-img' alt='' src={require('../Static/Project_IoT_infra.png')}></img>


        <div className="Hebrew-box">
            <h3>Cohen: Categorizing ancient Hebrew texts</h3>
            <p className="Hebrew-text">
            <div className='inner-hebrew-text'>
                Cohen is a Natural Language Processing algoritm that one of my students has developed. Cohen's language processing capabilities make it possible 
                to read ancient Hebrew texts and categorize them into different types of ancient Hebrew with a high degree of accuracy. This has been a great project to work on, 
                where my main role was to supervise and advise my student every step of the way (albeit he is the expert on ancient Hebrew, not me :P). <a href="https://github.com/gngpostalsrvc/COHeN">See here </a>
            </div>
            </p>
        </div>
        <img className='Hebrew-img' alt='' src={require('../Static/Hebrew.jpg')}></img>


        <div className="Social-Media-box">

            <h3>Semantic segmentation of social media posts</h3>
            <p className="Social-Media-text">
                I am currently working in a project with one of my students (and business partner) to create a way to process social media posts from various users 
                thereby developing an approach to connect multiple posts with one another in a semantic way. The semantics will support different use cases based on both deductive and 
                inductive reasoning. 

            </p>
        </div>
        <img className='Social-Media-img' alt='' src={require('../Static/Project_Social_Media.jpg')}></img>


        <div className="Cloud-migration-box">

            <h3>Cloud migration for a private company</h3>
            <p className="Cloud-migration-text">
                I was a key player in a massive cloud migration project for a big Norwegian private company some time ago.
                The project comprised many aspects from storage solutions, to computing services to analytics capabilities. I was responsible for the analytics and machine learning functionalities at first,
                but overtime I became a key player in virtually every aspect of the migration.

            </p>

        </div>
        <img className='Cloud-migration-img' alt='' src={require('../Static/Project_Cloud.jpg')}></img>


        <div className="Electricity-box">

            <h3>Electricity consumption modelling</h3>
            <p className="Electricity-text">
                Being able to predict what electricity is used for by specific households throughout the year can be a game changer in the Norwegian (and European) electricity market. In this sense, I was involved in a 
                project that strived to do just that. The final result was a working algoritm that could give good percentage-wise indications as to what electricity was being used for by households given their distinctive characteristics,
                such as number of people in the household, time of the year, geographical location and many other aspects. This solution was eventually implemented as a service in a mobile app whereby private customers could see a predicted breakdown
                of their electricity consumption, which can thereafter help them to choose the best electricity service contract based on their circumstances. 
            </p>

        </div>
        <img className='Electricity-img' alt='' src={require('../Static/Project_Electricity.jpg')}></img>




        </div>
    )
}

export default Projects;


// WEBPACK FOOTER //
// ./src/Components/Projects.js